export default {
  general: {
    settings: "設定",
    show_time: "時間表示を表示",
    show_seconds: "秒を表示",
    show_search: "検索バーを表示",
    show_wallpaper: "壁紙スキップボタンを表示",
    show_bookmark: "ブックマークボタンを表示",
    show_weather: "天気を表示",
    show_top_sites: "よく訪問するサイトを表示",
    auto_change_background: "背景を自動的に切り替える",
    auto_change_every: "切り替え間隔",
    days: "日",
    hours: "時間",
    minutes: "分",
    interval_required: "日、時間、分をすべて 0 にすることはできません",
    sync_enabled: "Todoクラウド同期",
    show_ai_chat: "AIチャットボタンを表示",
  },
  profile: {
    title: "プロフィール",
    logout: "ログアウト",
    sign_in: "サインイン",
    sign_in_desc: "完全な体験を利用するにはサインインしてください",
    avatar_updated: "アバターが正常に更新されました",
    nickname_updated: "ニックネームが正常に更新されました",
    avatar_size: "アバターファイルのサイズは500KBを超えないでください",
    login_required: "アバターを更新するにはログインする必要があります",
    login_success: "ログイン成功",
    user_avatar: "ユーザーアバター",
    edit_avatar: "アバターを編集",
    save: "保存",
    cancel: "キャンセル"
  },
  subscription: {
    title: "サブスクリプション",
    check: "サブスクリプションを確認",
    upgrade: "サブスクリプションをアップグレード",
    subscribe: "Tabbyに登録",
    expired_on: "期限切れ: {0}",
    expires_on: "有効期限: {0}",
    plans: {
      premium: "Tabbyのすべてを解放：無制限の壁紙、カスタム壁紙、限定コレクションをお楽しみください。",
      pro: "サブスクリプションをアップグレードして、無制限の壁紙、カスタム壁紙、限定コレクションを利用しましょう。",
      free: "サブスクライブして、無制限の壁紙、カスタム壁紙、限定コレクションを利用しましょう。"
    }
  },
  wallpaper: {
    title: "壁紙",
    upload: "カスタム背景をアップロード",
    upgrade_required: "カスタム背景機能を解除するにはPro/Premiumプランにアップグレードしてください",
    images: "画像",
    hues: "色調",
    anims: "アニメーション",
    diy: "DIY",
    get_new: "新規取得",
    upload_background: "背景をアップロード",
    add: "追加",
    remote_url: "リモート画像URL",
    size_tip: "背景ファイルが小さいほど、タブの読み込みが速くなります。ほとんどのブラウザでは、ファイルサイズの制限は1.5MBです。リモートURLには制限はありません。",
    please_login: "まずログインしてください",
    click_to_upload: "クリックしてアップロード",
    video_gif_image: "ビデオ、GIF、または画像",
    background: "背景",
    or_enter_remote_background_url: "またはリモート背景URLを入力",
    remote_url_placeholder: "https://example.com/image.jpg",
    custom_background_removed: "カスタム背景が削除されました",
    failed_to_load_background: "背景の読み込みに失敗しました",
    using_default: "代わりにデフォルトの背景を使用しています",
    insufficient_storage: "ストレージ不足",
    upload_failed: "アップロード失敗",
    success: "成功",
    remote_background_added: "リモート背景が追加されました",
    detecting_media_type: "メディアタイプを検出中...",
    invalid_media_type: "認識できないメディアタイプ",
    video_load_failed: "ビデオを読み込めません。URLが正しいか確認してください"
  },
  rewards: {
    title: "報酬",
    invite_friends: "友達を招待",
    get_access: "友達を招待して Pro の割引をアンロック",
    total_invites: "招待総数",
    your_discount: "あなたの割引",
    no_pro_yet: "まだありません",
    copy_link: "招待リンクをコピー",
    copied: "招待リンクがコピーされました！",
    copy_failed: "リンクのコピーに失敗しました",
    invite_description: "友達があなたのリンクで登録",
    receive_credits: "あなた: 1人招待 → 5%OFF、2人 → 8%OFF、3人 → 15%OFF、4人以上 → 20%OFF · 招待された友達は 5%OFF"
  },
  paywall: {
    title: "Tabby Pro",
    pro_active: "Pro 利用中",
    expires: "期限",
    free_plan: "無料プラン",
    tagline: "フルチャット枠、クラウド同期の Todo、すべての壁紙機能をこの拡張機能で解放。",
    monthly: "月額",
    yearly: "年額",
    month_period: "/月",
    year_period: "/年",
    billed_monthly: "月額払い · いつでも解約可",
    billed_yearly: "年払い",
    checkout_usd: "支払い",
    save_yearly: "月額より 17% お得",
    best_value: "ベストバリュー",
    referral_price: "紹介割引価格",
    save: "お得",
    subscribe_now: "今すぐ購読",
    current_plan: "現在のプラン",
    processing: "処理中",
    waiting_title: "お支払い待ち",
    waiting_desc: "新しく開いたウィンドウでお支払いを完了してください。",
    payment_completed: "支払い完了",
    having_issues: "問題が発生",
    invite_save: "友達を招待して Pro を割引",
    sign_in_first: "先にログインしてください",
    checkout_failed: "支払いセッションを作成できませんでした",
    payment_failed: "支払い失敗",
    payment_wrong: "エラーが発生しました。もう一度お試しください。",
    success_msg: "おめでとうございます！支払いが完了しました",
    not_paid_msg: "お支払いがまだ完了していません。ウィンドウで支払いを完了するか、もう一度お試しください。",
    verify_failed: "支払い状態を確認できませんでした。もう一度お試しいただくか、サポートにお問い合わせください。",
    contact_email: "メールでお問い合わせ: hi@tabbyio.com"
  },
  about: {
    title: "概要",
    version: "バージョン: 1.3.11",
    contact: "お問い合わせ:",
    privacy_policy: "プライバシーポリシー",
    terms_of_service: "利用規約"
  },
  tabs: {
    general: "好み",
    profile: "プロフィール",
    wallpaper: "壁紙",
    rewards: "報酬",
    about: "概要"
  },
  language: {
    title: "言語",
    en: "English",
    zh: "中文",
    de: "Deutsch",
    fr: "Français",
    pt: "Português",
    ru: "Русский",
    bn: "বাংলা",
    ja: "日本語",
    es: "Español"
  },
  buttons: {
    bookmark: "ブックマーク",
    next_background: "次の背景",
    ai_chat: "AIチャット",
    search_placeholder: "検索するか、Ctrl + Enterを押してAIチャットを使用...",
    attach: "ファイルを添付",
  },
  top_sites: {
    title: "よく訪問するサイト",
    error: "よく訪問するサイトを読み込めませんでした",
    empty: "よく訪問するサイトが見つかりません"
  },
  greetings: {
    morning: "おはようございます",
    afternoon: "こんにちは",
    evening: "こんばんは",
    morning_message: "新しい一日が始まりました。何かお手伝いできますか？",
    afternoon_message: "午後の時間です。何か質問はありますか？",
    evening_message: "夜の時間です。お話ししましょう！"
  },
  intro: {
    your_portal: "あなたのポータル",
    for: "のための",
    productivity: "生産性。",
    inspiration: "インスピレーション。",
    photography: "写真。",
    description: "新しいタブが、エレガンス、生産性、",
    description_continued: "そしてそれ以上のゲートウェイになります。",
    add_to_chrome: "Chromeに追加",
    free: "無料",
    try_now: "今すぐ試す",
    screenshot: "スクリーンショット"
  }
}

